'use strict';

import { isFieldEmpty, displayInputError } from '../../_assets/abbott/js/_helper';


export default class PoNumber {
  constructor() {

  	let $poList = $('.PoNumber__list'),
        $customInput = $poList.closest('.po-number__wrap').find('.CustomPoNumber');

  	$poList.on('change', function(e){
  		e.preventDefault();

  		let $this = $(this),
          selectedPo = $this.val(),
          $poCustom = $this.closest('.po-number__wrap').find('.CustomPoNumber');

  		if (selectedPo == 'custom') {
            $poCustom.parent().addClass('show');
        }
  		else {
            $poCustom.parent().removeClass('show');
        }
  	});

  	if($poList.val() === 'custom')
    {
        $customInput.parent().addClass('show');
    }

  }



  getPONumberSection($section){
    let $poNumberSection;

    switch ($section){
        case "updatePayment":
            $poNumberSection = $('.form-modal--edit-payment');
            break;
        case "updatePo":
            $poNumberSection = $('.form-modal--edit-purchaseordernumber');
            break;

        case "newRegimen":
            $poNumberSection = $('.form--payment');
            break;
    }

    return $poNumberSection;
  }

  //PO is mandatory if it is institution pays or copays
  isValidPONumber($section){

    let $poNumberSection = this.getPONumberSection($section);

    let $poNumberList = $poNumberSection.find('.PoNumber__list'),
        $customPoNumber = $poNumberSection.find('.CustomPoNumber'),
        isCustomPo = $customPoNumber.parent().is('.show'),
        isValid = true;

      if($poNumberList.is(':visible')){

          //values from the list
          if(isFieldEmpty($poNumberList)){
              displayInputError($poNumberList, false);
              isValid = false;
          }

          //if user selects to insert his own PO number
          if( isCustomPo && isFieldEmpty($customPoNumber)){
              displayInputError($customPoNumber, false);
               isValid = false;
          }
      }

      return isValid;
  }

  //define value for API
  getPONumber($section){

    let $poNumberSection = this.getPONumberSection($section);

    let $poNumberList = $poNumberSection.find('.PoNumber__list'),
        $customPoNumber = $poNumberSection.find('.CustomPoNumber'),
        poNumberValue;

    if(!isFieldEmpty($customPoNumber))
        poNumberValue = $customPoNumber.val();
    else
        poNumberValue = $poNumberList.val();

    return poNumberValue;
  }

}
